/** @format */

import { Navigate, Outlet } from "react-router-dom";
import Layout from "../components/Layout/Layout";

const AuthRoute = () => {
  const accessToken = localStorage.getItem("access_token");
  
  if (!accessToken) {
    return <Navigate to={"/home"} replace />; 
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default AuthRoute;

